export interface RepresentativeDataList {
  id: number;
  account_type: string;
  name: string;
  state: string;
  position: string;
  party: string;
  district: string;
}

export interface RepresentativeAccountData {
  id: number;
  account_type: string;
  photo_url: any;
  cover_photo_url: any;
  name: string;
  phone_number: string;
  email: string;
  gender: any;
  dob: any;
  state: string;
  local_government: any;
  polling_unit: any;
  created_at: string;
  position: string;
  party: string;
}

export const RepresentativeAccountDummyData = {
  id: 0,
  account_type: "",
  photo_url: "",
  cover_photo_url: "",
  name: "",
  phone_number: "",
  email: "",
  gender: "",
  dob: "",
  state: "",
  local_government: "",
  polling_unit: "",
  created_at: "",
  position: "",
  party: "",
};
